export default "__VITE_ASSET__CpQSXLeV__"